import produce from 'immer';
import {
	FETCH_NAVIGATION_PENDING,
	FETCH_NAVIGATION_FULFILLED,
	FETCH_NAVIGATION_FAILED,
	SET_MOBILE_NAVIGATION_STATE_FULFILLED,
	SET_HEADER_NAVIGATION_STATE_FULFILLED,
} from '../constants/actions/navigationActions';
import { SET_INITIAL_DATA_FULFILLED } from '../constants/actions/pageActions';

const navigationReducer = produce(
	(draft, action) => {
		switch (action.type) {
			case FETCH_NAVIGATION_PENDING: {
				draft.loading = true;
				draft.error = false;
				break;
			}
			case SET_INITIAL_DATA_FULFILLED: {
				draft.loading = false;
				draft.navigation = action.payload.data.navigation;
				draft.error = false;
				break;
			}
			case FETCH_NAVIGATION_FULFILLED: {
				draft.loading = false;
				draft.navigation = action.payload.nav;
				draft.error = false;
				break;
			}
			case FETCH_NAVIGATION_FAILED: {
				draft.loading = false;
				draft.error = false;
				break;
			}
			case SET_MOBILE_NAVIGATION_STATE_FULFILLED: {
				draft.mobileNavOpen = action.payload.open;
				break;
			}
			case SET_HEADER_NAVIGATION_STATE_FULFILLED: {
				draft.headerNavMenuOpen = action.payload.open;
				draft.headerNavMenuActiveId = action.payload.id;
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		navigation: null,
		loading: false,
		error: false,
		mobileNavOpen: false,
		headerNavMenuActiveId: 0,
		headerNavMenuOpen: false,
	}
);

export default navigationReducer;
